/* Saray Halı – koleksiyon filtresi */
(() => {
  if (window.__sarayFiltre) return;
  window.__sarayFiltre = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = () => $('[data-ss-root]');
  const ss = () => $('.ss');
  const sectionId = () => ss()?.dataset.sectionId;
  const isMobile = () => matchMedia('(max-width: 860px)').matches;
  const fmt = (n) => Number(n).toLocaleString('tr-TR', { maximumFractionDigits: 0 });

  let portal = null;
  let openPop = null;
  let openAcc = new Set(['room', 'size']);
  const cache = new Map();

  /* ---------- yardımcılar ---------- */
  const trUpper = (s) => s.replace(/i/g, 'İ').toUpperCase();
  const titleCase = (s) => s.split(' ').map((w) => (w ? trUpper(w[0]) + w.slice(1) : w)).join(' ');

  function formParams(form) {
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(form)) if (String(v).trim() !== '') p.append(k, v);
    return p;
  }
  function currentParams() {
    const p = new URLSearchParams(location.search);
    p.delete('page');
    return p;
  }
  function withSort(p) {
    const sort = currentParams().get('sort_by');
    if (sort && !p.has('sort_by')) p.set('sort_by', sort);
    return p;
  }
  // Önbellekte ham HTML tutulur; her kullanımda yeni belge üretilir (paylaşılan/bozulmuş DOM olmaz).
  const cacheKey = (params) => `${location.pathname}?section_id=${sectionId()}&${params}`;
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  function remember(url, html) {
    cache.delete(url);
    cache.set(url, html);
    if (cache.size > 40) cache.delete(cache.keys().next().value);
  }
  async function fetchSection(params) {
    const url = cacheKey(params);
    if (cache.has(url)) return parse(cache.get(url));
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const html = await res.text();
    const doc = parse(html);
    if ($('[data-ss-root] .ss', doc)) remember(url, html);
    return doc;
  }
  const pageUrl = (str) => `${location.pathname}${str ? '?' + str : ''}`;

  /* ---------- sayfayı yeniden çiz ---------- */
  let renderSeq = 0;
  async function render(params, { push = true } = {}) {
    const str = params.toString();
    const seq = ++renderSeq;
    clearTimeout(drawerTimer);
    ss()?.classList.add('is-loading');
    $('#ProductGridContainer .collection')?.classList.add('loading');
    let doc;
    try {
      doc = await fetchSection(str);
    } catch (err) {
      if (seq === renderSeq) location.href = pageUrl(str);
      return;
    }
    if (seq !== renderSeq) return; // daha yeni bir istek var; bu cevap eskidi
    const fresh = $('[data-ss-root]', doc);
    if (!fresh || !$('.ss', fresh) || !root()) { location.href = pageUrl(str); return; }
    // Cevap geldiğinde kullanıcı hangi pencereyi açık tutuyorsa onu yeniden aç
    const keep = openPop;
    closeDrawer(true);
    root().innerHTML = fresh.innerHTML;
    if (push) history.pushState({ ssParams: str }, '', pageUrl(str));
    init();
    if (typeof loadMore === 'function' && $('.js-load-more, .js-infinite-scroll')) loadMore();
    if (typeof colorSwatches === 'function') colorSwatches();
    if (keep && !isMobile()) showPop(keep);
  }

  /* ---------- portal: pencere ve çekmeceyi body altına taşı ---------- */
  function setupPortal() {
    if (portal) portal.remove();
    portal = document.createElement('div');
    portal.className = 'ss';
    portal.id = 'ss-portal';
    document.body.appendChild(portal);
    $$('[data-ss-popover], [data-ss-scrim], [data-ss-drawer]', root()).forEach((el) => portal.appendChild(el));
  }

  /* ---------- görsel durumlar ---------- */
  function decorate(scope) {
    $$('[data-ss-tc]', scope).forEach((el) => { el.textContent = titleCase(el.textContent.trim()); });
    // ölçü kutularını m²'ye göre sırala
    $$('[data-ss-sizes]', scope).forEach((box) => {
      const pairs = $$('input[data-area]', box).map((i) => [i, i.nextElementSibling]);
      pairs.sort((a, b) => a[0].dataset.area - b[0].dataset.area).forEach(([i, l]) => { box.appendChild(i); box.appendChild(l); });
    });
    $$('form[data-ss-form]', scope).forEach(syncForm);
  }
  const GROUPS = {
    kucuk: (w, h, a) => a < 2,
    orta: (w, h, a) => a >= 2 && a < 4,
    buyuk: (w, h, a) => a >= 4,
    yolluk: (w, h) => Math.min(w, h) <= 100 && Math.max(w, h) >= 150,
  };
  const groupInputs = (form, g) => $$('input[data-area]', form).filter((i) => GROUPS[g](+i.dataset.w, +i.dataset.h, +i.dataset.area) && !i.disabled);
  function syncForm(form) {
    $$('[data-ss-group]', form).forEach((b) => {
      const ins = groupInputs(form, b.dataset.ssGroup);
      b.classList.toggle('is-on', ins.length > 0 && ins.every((i) => i.checked));
    });
    const oz = $$('[data-ss-ozel]', form);
    $$('[data-ss-ozel-toggle]', form).forEach((b) => {
      const on = oz.length > 0 && oz.some((i) => i.checked);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
    });
    $$('[data-ss-price]', form).forEach(syncPrice);
  }
  function syncPrice(box) {
    const max = +box.dataset.max;
    const imin = $('[data-ss-imin]', box), imax = $('[data-ss-imax]', box);
    const lo = parseInt(String(imin.value).replace(/\D/g, '')) || 0;
    const hi = parseInt(String(imax.value).replace(/\D/g, '')) || max;
    $('[data-ss-rmin]', box).value = lo;
    $('[data-ss-rmax]', box).value = hi;
    const range = $('.ss-range', box);
    range.style.setProperty('--l', (lo / max) * 100 + '%');
    range.style.setProperty('--r', (hi / max) * 100 + '%');
    $$('[data-ss-pq]', box).forEach((b) => {
      const [a, z] = b.dataset.ssPq.split('-');
      b.classList.toggle('is-on', String(lo) === a && (z ? String(hi) === z : (imax.value === '' || hi >= max)) && (imin.value !== '' || imax.value !== ''));
    });
  }

  /* ---------- hızlı filtre penceresi ---------- */
  function showPop(key) {
    if (isMobile()) { openDrawer(key); return; }
    if (openPop === key) { closePop(); return; }
    closePop();
    const pop = portal && $(`[data-ss-popover="${key}"]`, portal);
    const pill = $(`[data-ss-pop="${key}"]`, root());
    if (!pill) return;
    if (!pop) { location.reload(); return; } // arayüz eksik kaldıysa donmak yerine sayfayı yenile
    pop.hidden = false;
    const r = pill.getBoundingClientRect();
    pop.style.left = Math.max(16, Math.min(r.left + scrollX, innerWidth - pop.offsetWidth - 16)) + 'px';
    pop.style.top = r.bottom + scrollY + 10 + 'px';
    pill.setAttribute('aria-expanded', 'true');
    openPop = key;
  }
  function closePop() {
    if (!openPop) return;
    const pop = portal && $(`[data-ss-popover="${openPop}"]`, portal);
    if (pop) pop.hidden = true;
    $(`[data-ss-pop="${openPop}"]`, root())?.setAttribute('aria-expanded', 'false');
    openPop = null;
  }
  function popParams(form, clear = false) {
    const keys = form.dataset.ssParams.split(' ').filter(Boolean);
    const p = currentParams();
    keys.forEach((k) => p.delete(k));
    if (!clear) for (const [k, v] of formParams(form)) p.append(k, v);
    return p;
  }
  let popTimer;
  function commitPop(form, delay = 0) {
    clearTimeout(popTimer);
    popTimer = setTimeout(() => render(popParams(form)), delay);
  }

  /* ---------- çekmece ---------- */
  function openDrawer(focus) {
    closePop();
    const d = portal && $('[data-ss-drawer]', portal);
    if (!d) { location.reload(); return; }
    if (focus) openAcc = new Set([focus]);
    $$('[data-ss-acc]', d).forEach((s) => setAcc(s, openAcc.has(s.dataset.ssAcc)));
    $('[data-ss-scrim]', portal).hidden = false;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (focus) $(`[data-ss-acc="${focus}"]`, d)?.scrollIntoView({ block: 'start' });
  }
  function closeDrawer(silent) {
    const d = portal && $('[data-ss-drawer]', portal);
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    $('[data-ss-scrim]', portal).hidden = true;
    document.documentElement.style.overflow = '';
    if (!silent) {
      // uygulanmamış seçimleri geri al
      drawerSeq++; // bekleyen çekmece güncellemesi artık uygulanmasın
      clearTimeout(drawerTimer);
      portal.classList.remove('is-loading');
      const html = cache.get(cacheKey(currentParams()));
      if (html) replaceDrawerBody(parse(html));
    }
  }
  function setAcc(sec, open) {
    sec.classList.toggle('is-open', open);
    $('[data-ss-acc-toggle]', sec)?.setAttribute('aria-expanded', open);
  }
  function drawerParams() {
    return withSort(formParams($('[data-ss-form="drawer"]', portal)));
  }
  function replaceDrawerBody(doc) {
    const body = $('[data-ss-form="drawer"]', portal);
    const freshBody = $('[data-ss-form="drawer"]', doc);
    if (!body || !freshBody) return;
    const scroll = body.scrollTop;
    const fit = $('[data-ss-fit]', body);
    const fitState = fit ? [$('[data-ss-fit-w]', fit).value, $('[data-ss-fit-h]', fit).value, $('[data-ss-fit-msg]', fit).innerHTML, $('[data-ss-fit-msg]', fit).className] : null;
    body.innerHTML = freshBody.innerHTML;
    $$('[data-ss-acc]', body).forEach((s) => setAcc(s, openAcc.has(s.dataset.ssAcc)));
    if (fitState) {
      const f = $('[data-ss-fit]', body);
      if (f) { $('[data-ss-fit-w]', f).value = fitState[0]; $('[data-ss-fit-h]', f).value = fitState[1]; $('[data-ss-fit-msg]', f).innerHTML = fitState[2]; $('[data-ss-fit-msg]', f).className = fitState[3]; }
    }
    decorate(body);
    body.scrollTop = scroll;
    const n = $('.ss', doc)?.dataset.count ?? '0';
    setCount($('[data-ss-drawer]', portal), n);
  }
  function setCount(scope, n) {
    $$('[data-ss-n]', scope).forEach((el) => { el.textContent = n; });
    const btn = $('[data-ss-apply]', scope);
    if (btn) {
      btn.disabled = n === '0';
      if (n === '0') btn.textContent = 'Sonuç yok';
      else if (!$('[data-ss-n]', btn)) btn.innerHTML = `<span data-ss-n>${n}</span> ürünü göster`;
    }
  }
  let drawerTimer;
  let drawerSeq = 0;
  function refreshDrawer() {
    clearTimeout(drawerTimer);
    const seq = ++drawerSeq;
    portal.classList.add('is-loading');
    drawerTimer = setTimeout(async () => {
      try {
        const doc = await fetchSection(drawerParams().toString());
        if (seq === drawerSeq) replaceDrawerBody(doc);
      } catch (err) {
        // sayım güncellenemedi; seçimler yine de "ürünü göster" ile uygulanabilir
      }
      if (seq === drawerSeq) portal.classList.remove('is-loading');
    }, 250);
  }

  /* ---------- alan aracı (oda ölçüsü → uygun halı ölçüleri) ---------- */
  function runFit(fit) {
    const form = fit.closest('form');
    const msg = $('[data-ss-fit-msg]', fit);
    const W = parseInt($('[data-ss-fit-w]', fit).value) || 0;
    const H = parseInt($('[data-ss-fit-h]', fit).value) || 0;
    if (W < 40 || H < 40) {
      msg.className = 'ss-fit__msg is-bad';
      msg.textContent = 'Lütfen en ve boyu santimetre olarak girin (ör. 300 × 400).';
      return false;
    }
    const mg = (x) => (x >= 200 ? 40 : 10);
    const a = Math.min(W, H), b = Math.max(W, H);
    const A = a - mg(a), B = b - mg(b);
    const sizes = $$('input[data-area]', form).filter((i) => !i.disabled);
    const fits = sizes
      .filter((i) => Math.min(+i.dataset.w, +i.dataset.h) <= A && Math.max(+i.dataset.w, +i.dataset.h) <= B)
      .sort((x, y) => y.dataset.area - x.dataset.area);
    const seen = new Set();
    const best = fits.filter((i) => (seen.has(i.dataset.area) ? false : seen.add(i.dataset.area))).slice(0, 2);
    sizes.forEach((i) => { i.checked = false; });
    const oz = $$('[data-ss-ozel]', form);
    oz.forEach((i) => { i.checked = false; });
    const lbl = (i) => `${i.dataset.w}×${i.dataset.h}`;
    if (!best.length) {
      oz.forEach((i) => { i.checked = true; });
      msg.className = 'ss-fit__msg is-bad';
      msg.innerHTML = `Hazır ölçülerimiz ${W}×${H} cm alana sığmıyor. <b>Özel kesim</b> modellerini gösteriyoruz; tam ölçünüzde kestirebilirsiniz.`;
    } else {
      best.forEach((i) => { i.checked = true; });
      const ratio = best[0].dataset.area / ((W * H) / 1e4);
      msg.className = 'ss-fit__msg is-ok';
      msg.innerHTML = `${W}×${H} cm için en uygun: <b>${best.map(lbl).join(', ')}</b>. ` +
        (ratio < 0.35 && oz.length ? 'Alan geniş; tam ölçüde <b>özel kesim</b> de yaptırabilirsiniz.' : 'Kartlarda bu ölçülerin fiyatı görünür.');
    }
    syncForm(form);
    return true;
  }

  /* ---------- form içi değişiklik ---------- */
  function onFormChange(form, delay = 0) {
    syncForm(form);
    if (form.dataset.ssForm === 'pop') commitPop(form, delay);
    else refreshDrawer();
  }

  /* ---------- olaylar ---------- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    const pill = t.closest('[data-ss-pop]');
    if (pill) { e.stopPropagation(); showPop(pill.dataset.ssPop); return; }
    if (t.closest('[data-ss-open]')) { openDrawer(); return; }
    if (t.closest('[data-ss-dclose]') || t.closest('[data-ss-scrim]')) { closeDrawer(); return; }
    if (t.closest('[data-ss-apply]')) { render(drawerParams()); return; }
    if (t.closest('[data-ss-dclear]')) {
      const f = $('[data-ss-form="drawer"]', portal);
      $$('input[type=checkbox]', f).forEach((i) => { i.checked = false; });
      $$('[data-ss-imin], [data-ss-imax]', f).forEach((i) => { i.value = ''; });
      onFormChange(f);
      return;
    }
    const acc = t.closest('[data-ss-acc-toggle]');
    if (acc) {
      const sec = acc.closest('[data-ss-acc]');
      const open = !sec.classList.contains('is-open');
      setAcc(sec, open);
      open ? openAcc.add(sec.dataset.ssAcc) : openAcc.delete(sec.dataset.ssAcc);
      return;
    }
    const link = t.closest('a[data-ss-link]');
    if (link) {
      e.preventDefault();
      render(new URL(link.href, location.origin).searchParams);
      return;
    }
    const form = t.closest('form[data-ss-form]');
    if (form) {
      const g = t.closest('[data-ss-group]');
      if (g) {
        const ins = groupInputs(form, g.dataset.ssGroup);
        const all = ins.length && ins.every((i) => i.checked);
        ins.forEach((i) => { i.checked = !all; });
        onFormChange(form);
        return;
      }
      if (t.closest('[data-ss-ozel-toggle]')) {
        const oz = $$('[data-ss-ozel]', form);
        const on = oz.some((i) => i.checked);
        oz.forEach((i) => { i.checked = !on; });
        onFormChange(form);
        return;
      }
      const ptab = t.closest('[data-ss-ptab]');
      if (ptab) {
        const box = ptab.closest('[data-ss-price]');
        $$('[data-ss-ptab]', box).forEach((b) => b.classList.toggle('is-on', b === ptab));
        $$('[data-ss-ppanel]', box).forEach((p) => { p.hidden = p.dataset.ssPpanel !== ptab.dataset.ssPtab; });
        return;
      }
      const pq = t.closest('[data-ss-pq]');
      if (pq) {
        const [a, z] = pq.dataset.ssPq.split('-');
        const imin = $('[data-ss-imin]', form), imax = $('[data-ss-imax]', form);
        const already = pq.classList.contains('is-on');
        imin.value = already || a === '0' ? '' : a;
        imax.value = already || !z ? '' : z;
        onFormChange(form);
        return;
      }
      if (t.closest('[data-ss-fit-go]')) {
        if (runFit(t.closest('[data-ss-fit]'))) onFormChange(form);
        return;
      }
      if (t.closest('[data-ss-clear-group]')) { render(popParams(form, true)); return; }
      if (t.closest('[data-ss-close]')) { closePop(); return; }
    }
    if (openPop && !t.closest('[data-ss-popover]')) closePop();
  });

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (t.matches('[data-ss-sort]')) {
      const p = currentParams();
      p.set('sort_by', t.value);
      render(p);
      return;
    }
    const form = t.closest('form[data-ss-form]');
    if (!form) return;
    if (t.matches('[data-ss-fit-w], [data-ss-fit-h]')) return;
    if (t.matches('[data-ss-rmin], [data-ss-rmax]')) {
      const box = t.closest('[data-ss-price]');
      const max = +box.dataset.max;
      const lo = +$('[data-ss-rmin]', box).value, hi = +$('[data-ss-rmax]', box).value;
      $('[data-ss-imin]', box).value = lo > 0 ? Math.min(lo, hi) : '';
      $('[data-ss-imax]', box).value = hi < max ? Math.max(lo, hi) : '';
    }
    onFormChange(form, t.matches('[data-ss-imin], [data-ss-imax]') ? 400 : 0);
  });

  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!t.matches('[data-ss-rmin], [data-ss-rmax]')) return;
    const box = t.closest('[data-ss-price]');
    const rmin = $('[data-ss-rmin]', box), rmax = $('[data-ss-rmax]', box);
    if (+rmin.value > +rmax.value) (t === rmin ? rmin : rmax).value = t === rmin ? rmax.value : rmin.value;
    const max = +box.dataset.max;
    const range = $('.ss-range', box);
    range.style.setProperty('--l', (rmin.value / max) * 100 + '%');
    range.style.setProperty('--r', (rmax.value / max) * 100 + '%');
    $('[data-ss-imin]', box).value = +rmin.value > 0 ? rmin.value : '';
    $('[data-ss-imax]', box).value = +rmax.value < max ? rmax.value : '';
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { closePop(); closeDrawer(); }
    if (e.key === 'Enter' && e.target.matches('[data-ss-fit-w], [data-ss-fit-h]')) {
      e.preventDefault();
      $('[data-ss-fit-go]', e.target.closest('[data-ss-fit]'))?.click();
    }
    if (e.key === 'Enter' && e.target.matches('[data-ss-imin], [data-ss-imax]')) e.preventDefault();
  });

  addEventListener('resize', () => closePop());
  addEventListener('popstate', () => render(currentParams(), { push: false }));

  function init() {
    if (!root()) return;
    openPop = null;
    // İlk açılışta, pencereler portala taşınmadan ÖNCE bölümün tam hâlini sakla
    // (eskiden portal sonrası kopya saklanıyordu → geri dönüşte pencereler kayboluyordu).
    const key = $('.ss', root()) ? cacheKey(currentParams()) : null;
    if (key && !cache.has(key)) remember(key, root().outerHTML);
    setupPortal();
    decorate(root());
    decorate(portal);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
